import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import StarRating from './StarRating';
import { reviewsAPI } from '../services/api';
import '../styles/ReviewForm.css';

const ReviewForm = ({ orderId, sellerName, onSuccess, onCancel }) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (rating === 0) {
      setError(t('reviews.selectRating'));
      return;
    }

    setLoading(true);
    setError('');

    try {
      await reviewsAPI.create(orderId, rating, comment);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setError(err.response?.data?.message || t('reviews.sendError'));
    } finally {
      setLoading(false);
    }
  };

  const ratingLabels = {
    1: t('reviews.veryBad'),
    2: t('reviews.bad'),
    3: t('reviews.ok'),
    4: t('reviews.good'),
    5: t('reviews.excellent')
  };

  return (
    <div className="review-form-container">
      <div className="review-form-header">
        <h3>{t('reviews.title')}</h3>
        <p>{t('reviews.question', { name: sellerName })}</p>
      </div>

      <form onSubmit={handleSubmit} className="review-form">
        <div className="rating-section">
          <label>{t('reviews.yourRating')}</label>
          <div className="rating-input">
            <StarRating
              rating={rating}
              size="xlarge"
              editable={true}
              onChange={setRating}
            />
            {rating > 0 && (
              <span className="rating-label">{ratingLabels[rating]}</span>
            )}
          </div>
        </div>

        <div className="comment-section">
          <label htmlFor="comment">{t('reviews.commentLabel')}</label>
          <textarea
            id="comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={t('reviews.commentPlaceholder')}
            rows={4}
            maxLength={500}
          />
          <span className="char-count">{t('reviews.charCount', { count: comment.length })}</span>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="form-actions">
          {onCancel && (
            <button type="button" className="btn-cancel" onClick={onCancel}>
              {t('reviews.later')}
            </button>
          )}
          <button type="submit" className="btn-submit" disabled={loading || rating === 0}>
            {loading ? t('reviews.submitting') : t('reviews.submit')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReviewForm;
